import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import {ThemeProvider} from './context/ThemeProvider';
import {ToastProvider} from './context/ToastProvider';
import {ConfirmProvider} from './context/ConfirmProvider';
import {AuthProvider} from './context/AuthProvider';
import {UpgradeProvider} from './context/UpgradeProvider';
import {NotesProvider} from './context/NotesProvider';
import {AppShell} from './components/layout/AppShell';
import {NotesPage} from './pages/NotesPage';
import {NoteDetailPage} from './pages/NoteDetailPage';
import {AskAiPage} from './pages/AskAiPage';
import {SettingsPage} from './pages/SettingsPage';
import {PublicNotePage} from './pages/PublicNotePage';

const router = createBrowserRouter([
  // Public share pages live outside AppShell — no login gate.
  {path: '/n/:shareId', element: <PublicNotePage />},
  {
    path: '/',
    element: <AppShell />,
    children: [
      {index: true, element: <Navigate to="/notes" replace />},
      {path: 'notes', element: <NotesPage />},
      {path: 'notes/:noteId', element: <NoteDetailPage />},
      {path: 'ask', element: <AskAiPage />},
      {path: 'settings', element: <SettingsPage />},
      {path: '*', element: <Navigate to="/notes" replace />},
    ],
  },
]);

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <ConfirmProvider>
          <AuthProvider>
            <UpgradeProvider>
              <NotesProvider>
                <RouterProvider router={router} />
              </NotesProvider>
            </UpgradeProvider>
          </AuthProvider>
        </ConfirmProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
